import { put, all, call, select, takeEvery, takeLatest, fork, cancel } from 'redux-saga/effects';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import { change, changeData } from 'circe/queryListing/actions';
import { getResults } from 'circe/queryListing/selectors';
import { assign } from 'domain/shipment/assign/actions';
import * as api from 'domain/shipment/assign/api';
import actionTypes from 'domain/shipment/assign/actionTypes';
import { REDUCER_NAME } from 'domain/shipment/assign/constants';

function* doAssign(action) {
  yield put(change(REDUCER_NAME, 'isAssigning', true));

  const state = yield select();

  try {
    const { payload } = action;
    const { filters } = payload;
    filters.shippers = filters.shippers ? [filters.shippers] : null;

    const resp = yield call(api.assign, filters);

    if (!resp) {
      throw new Error('Fetch Shipments failed to load');
    }

    yield put(change(REDUCER_NAME, 'isAssigning', false));

    yield put(change(REDUCER_NAME, 'totalAssigned', resp.length));

    yield put(change(REDUCER_NAME, 'data', []));

    yield put(
      showNotification(
        I18n.str('shipmentsWillBeAssigned', 'Shipments will be assigned. You will get notified'),
        'success',
      ),
    );
  } catch (e) {
    let message = I18n.str('unableToAssignShipments', 'Unable to assign shipments.');
    if (e.code && e.code.status === 400) {
      message = e.code?.message || e.code?.error || message;
    }

    yield put(showNotification(message, 'error'));

    yield put(change(REDUCER_NAME, 'isAssigning', false));
    exception(e);
  }
}

function* doFetched() {
  yield put(change(REDUCER_NAME, 'totalAssigned', undefined));
}

export default function*() {
  yield all([takeLatest(assign().type, doAssign), takeLatest(actionTypes.FETCHED, doFetched)]);
}
